<script setup lang="ts">
import { defineProps, computed } from "vue";
import { PropType } from "@vue/runtime-core";
import { TariffOptionStruct } from "@/struct/TariffStruct";
import { useI18n } from "vue-i18n";

const props = defineProps({
  option: {
    type: Object as PropType<TariffOptionStruct>,
    required: true,
  },
});
const { t } = useI18n();

const getUnit = computed(() => {
  switch (props.option.id) {
    case "sms":
      return t("common.units.sms");
    case "gb":
      return t("common.units.gb");
    case "min":
      return t("common.units.min");
    default:
      return "";
  }
});

const fullness = computed(() => {
  return Math.floor(100 - (props.option?.value / props.option?.maximum) * 100);
});
</script>

<template>
  <div class="tariff-main-option">
    <div
      :style="`width: ${fullness}%`"
      class="tariff-main-option__progress"
    ></div>
    <div class="tariff-main-option__wrapper">
      <div class="tariff-main-option__value h3 color-white">
        <span>{{ option.value }} {{ getUnit }}</span>
      </div>
      <div
        class="tariff-main-option__maximum caption-small normal color-text-tertiary"
      >
        <span>{{ t("common.labels.of") }} {{ option.maximum }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/style/main";

.tariff-main-option {
  width: 100%;
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  min-width: 116px;
  background: var(--color-tertiary);

  @media (max-width: 1100px) {
    min-width: 105px;
  }
  @media (max-width: 768px) {
    min-width: 92px;
  }

  @media (max-width: 370px) {
    min-width: unset;
  }

  &__progress {
    background-color: var(--color-bg-secondary);
    width: 100%;
    height: 100%;
    position: absolute;
    right: 0;
  }

  &__wrapper {
    position: relative;
    z-index: 1;
    padding: 24px 15px;

    @media (max-width: 650px) {
      text-align: center;
    }

    @media (max-width: 380px) {
      padding: 14px 0 14px 10px;
      display: flex;
      flex-flow: column;
      align-items: flex-start;
      justify-content: center;
    }
  }

  &__value {
    text-wrap: nowrap;
  }
}
</style>
